import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './plugins/pinia'

// Import template CSS files (in correct order)
import './assets/styles/main.css' // Our Tailwind first
import '@/assets/css/tabler-icons.css'
import '@/assets/css/style.css'
import '@/assets/css/vue.css'
import '@/assets/css/feather.css'
// Skip template's tailwind.css as it conflicts with our Tailwind 4
// Skip flowbite.css as we're using flowbite plugin in Tailwind config

import { useAuthStore } from './stores/auth'
import { useUiStore } from './stores/ui'

const app = createApp(App)

app.use(pinia)
app.use(router)

const authStore = useAuthStore()
const uiStore = useUiStore()

// Initialize auth (async) and UI (sync), then mount
// Auth initialization will verify token with backend and redirect to login if expired
async function bootstrap() {
  await authStore.initializeAuth()
  uiStore.initializeUI()
  app.mount('#app')
}

bootstrap()
